/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `Property` - Proprietate
 * * `Lease` - Închiriere
 * * `Leasing` - Leasing
 * * `PowerOfAttorney` - Power of attorney
 */
export enum PossessionBaseEnum {
  PROPERTY = 'Property',
  LEASE = 'Lease',
  LEASING = 'Leasing',
  POWER_OF_ATTORNEY = 'PowerOfAttorney',
}
